// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"6012b11d","644":"6012b11d","781":"3812005a","985":"283686c7"}[chunkId] + ".css";
};